import { render } from "./IndexVehicule.vue?vue&type=template&id=2aae1bad"
import script from "./IndexVehicule.vue?vue&type=script&lang=js"
export * from "./IndexVehicule.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__